import { Component } from "react";
import { connect } from "react-redux";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";

import * as actions from '../../store/ducks/agentPayout/actions';
import { withNamespaces } from "react-i18next";
import { filterErrorHandler } from "../../hoc/Shared/utility";
import Swal from "sweetalert2";
import Button from '../../components/Button/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import DataTable from "../../components/Datatable/DataTable";
import Skeleton from "react-loading-skeleton";

class AgentDownlinePayoutDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activePage : 1,
            limit: 10,
            totalRecord: 0,
            searchValue: '',
            order: '',

            data: [],
            agentDetails: [],
            loading: true,
            loadOnce: true
        }
    }

    componentDidMount() {
        const listingArr = this.getFilterArray();
        
        if (this.props.downlineAgentPayoutDetailsParam.orderId !== null) {
            this.props.funcGetDownlineAgentPayoutHistoryDetails(listingArr)
        } else {
            this.props.funcGetDownlineAgentPayoutDetails(listingArr);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.downlineAgentPayoutDetails !== this.props.downlineAgentPayoutDetails && nextProps.downlineAgentPayoutDetails !== undefined) {
            if (nextProps.downlineAgentPayoutDetails.responseCode === 200 && nextProps.downlineAgentPayoutDetails.msgType === 'success') {
                this.setState({
                    agentDetails: nextProps.downlineAgentPayoutDetails.data.upline_agent,
                    data: nextProps.downlineAgentPayoutDetails.data.result.row,
                    totalRecord: nextProps.downlineAgentPayoutDetails.data.result.pagination.total_record,
                    loading: false,
                    loadOnce: false
                });
            } else {
                this.setState({
                    agentDetails: [],
                    data: [],
                    totalRecord: 0,
                    activePage: 1,
                    loading: false,
                    loadOnce: false
                }, () => {
                    filterErrorHandler(nextProps.downlineAgentPayoutDetails.message);
                })
            }
            Swal.close();
        }

        if (nextProps.downlineAgentPayoutHistoryDetails !== this.props.downlineAgentPayoutHistoryDetails && nextProps.downlineAgentPayoutHistoryDetails !== undefined) {
            if (nextProps.downlineAgentPayoutHistoryDetails.responseCode === 200 && nextProps.downlineAgentPayoutHistoryDetails.msgType === 'success') {
                this.setState({
                    agentDetails: nextProps.downlineAgentPayoutHistoryDetails.data.upline_agent,
                    data: nextProps.downlineAgentPayoutHistoryDetails.data.result.row,
                    totalRecord: nextProps.downlineAgentPayoutHistoryDetails.data.result.pagination.total_record,
                    loading: false,
                    loadOnce: false
                });
            } else {
                this.setState({
                    agentDetails: [],
                    data: [],
                    totalRecord: 0,
                    activePage: 1,
                    loading: false,
                    loadOnce: false
                }, () => {
                    filterErrorHandler(nextProps.downlineAgentPayoutHistoryDetails.message);
                })
            }
            Swal.close();

        }
        return true;
    }

    getFilterArray = () => {
        const listingArr = {};
        const param = this.props.downlineAgentPayoutDetailsParam;

        listingArr.page = this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.search = this.state.searchValue;
        listingArr.order = JSON.stringify(this.state.order);
        listingArr.aid = param.aid;
        listingArr.date = param.date;
        listingArr.order_id = param.orderId;

        this.setState({
            loading: true,
            data: []
        });
        
        return listingArr;
    }

    refreshHandler = () => {
        const listingArr = this.getFilterArray();

        if (this.props.downlineAgentPayoutDetailsParam.orderId !== null) {
            this.props.funcGetDownlineAgentPayoutHistoryDetails(listingArr)
        } else {
            this.props.funcGetDownlineAgentPayoutDetails(listingArr);
        }
    }

    noFormatter = (cell, row, rowIndex) => {
        let rowNumber = ((this.state.activePage - 1) * this.state.limit) + (rowIndex + 1);

        return <span>{rowNumber}</span>
    }

    onSort = (field, order) => {
        const orderArry = [{}];
        let orderSequence = (order === 'asc') ? true : false;

        orderArry[0]['id'] = field;
        orderArry[0]['desc'] = orderSequence;

        this.setState({
            order: orderArry
        }, () => {
            this.refreshHandler();
        })
    }

    dataTableChangeHandler = (val, act) => {
        this.setState({
            [act]: (act === 'searchValue') ? val.target.value : val
        }, () => {
            this.refreshHandler();
        })
    }

    render() {
        const { t } = this.props;
        let display = null;
        const num_format = { maximumFractionDigits: 2, minimumFractionDigits: 2 };

        if (this.state.agentDetails) {
            

          const num_format = { maximumFractionDigits: 2, minimumFractionDigits: 2 };

const columns = [
  {
    text: t('global.no'),
    dataField: 'no',
    formatter: (cell, row, rowIndex) => {
      // keep consistent row numbering with pagination
      const rowNumber = ((this.state.activePage - 1) * this.state.limit) + (rowIndex + 1);
      return <span>{rowNumber}</span>;
    },
    headerStyle: { width: '60px', textAlign: 'center' }
  },
  {
    text: t('agent-payout.agent'),
    dataField: 'agent',
    sort: true,
    onSort: this.onSort,
  },
  {
    text: t('agent-payout.base-currency'),
    dataField: 'currency'
  },
  {
    // Win/Lose (USD)
    text: `${t('agent-payout.win-lose')} (${t('global.currency.usd')})`,
    dataField: 'win_lose',
    sort: true,
    onSort: this.onSort,
    formatter: (cell, row) => new Intl.NumberFormat('en-US', num_format).format(row.win_lose)
  },
  {
    // Deducts (USD)
    text: `Deducts (${t('global.currency.usd')})`,
    dataField: 'deducts',
    sort: true,
    onSort: this.onSort,
    formatter: (cell, row) => {
      const permission = this.props.currentUser && this.props.currentUser.permission ? this.props.currentUser.permission : [];
      const deductsValue = new Intl.NumberFormat('en-US', num_format).format(row.deducts);
      
      // Make clickable if user has permission and deducts > 0
      if (permission.includes('agent_payout_details') && parseFloat(row.deducts || 0) > 0) {
        return (
          <b>
            <a href='/#' onClick={(event) => this.props.deductDetailsHandler(event, row.aid, this.props.downlineAgentPayoutDetailsParam.date, null)}>
              {deductsValue}
              <i className='fas fa-external-link-square-alt text-primary ml-1'></i>
            </a>
          </b>
        );
      }
      
      return deductsValue;
    }
  },
  {
    // Final amount = (win_lose - deducts), shown to help users reconcile
    text: `${t('agent-payout.final-amt')} (${t('global.currency.usd')})`,
    dataField: 'final_amt',
    sort: true,
    onSort: this.onSort,
    formatter: (cell, row) => {
      const finalAmt = (parseFloat(row.win_lose || 0) - parseFloat(row.deducts || 0));
      return new Intl.NumberFormat('en-US', num_format).format(finalAmt);
    }
  },
  {
    // Downline’s own commission before sharing up
    text: `${t('agent-payout.payout-usd')} (${t('global.currency.usd')})`,
    dataField: 'agent_payout',
    sort: true,
    onSort: this.onSort,
    formatter: (cell, row) => {
      // agent_payout is (win_lose - deducts) * percentage_own%
      const expl = `(${row.win_lose}-${row.deducts})*${row.percentage_own}%`;
      const val = new Intl.NumberFormat('en-US', num_format).format(row.agent_payout);
      return (
        <div>
          <b>{val}</b><br />
          <small>{expl}</small>
        </div>
      );
    }
  },
  {
    // Share % shown (10% for L1, 1% for L2)
    text: t('agent-payout.share-percentage'),
    dataField: 'share_pct',
    sort: true,
    onSort: this.onSort,
    formatter: (cell, row) => <span>{row.share_pct}%</span>,
    headerStyle: { width: '140px' },
  },
  {
    // What upline actually receives from this downline row
    text: `${t('agent-payout.actual-total-payout')} (${t('global.currency.usd')})`,
    dataField: 'actual_total_payout',
    sort: true,
    onSort: this.onSort,
    formatter: (cell, row) => {
      const val = new Intl.NumberFormat('en-US', num_format).format(row.actual_total_payout);
      return (
        <div>
          <b>{val}</b><br />
          <small>{new Intl.NumberFormat('en-US', num_format).format(row.agent_payout)} * {row.share_pct}%</small>
        </div>
      );
    }
  },
];



            display = 
                <Auxiliary>
                    <div className="breadcrumb-header">
                        <div className="d-flex">
                            <Button 
                                typeButton="button" 
                                classValue="btn btn-back-outline" 
                                idValue="back" buttonName={<i className="angle fe fe-chevron-left"></i>}
                                clicked={() => this.props.changePageHandler(this.props.downlineAgentPayoutDetailsParam.returnPage)}
                            />
                            <div className="my-auto">
                                <div className="member-name">
                                    <FontAwesomeIcon icon={faUser}/> 
                                    {this.state.agentDetails.agent}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row row-sm">
                        <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                            <div className="card box-shadow-0">
                                <div className="card-header">
                                    <h4 className="card-title mb-g-0">
                                        {t('agent-payout.agent-details')}
                                    </h4>
                                </div>
                                <div className="card-body pt-0">
                                    {(this.state.loading && this.state.loadOnce)
                                        ?
                                        <Skeleton count={3} />
                                        :
                                        <table className="table table-bordered table-hover">
                                            <tbody>
                                                <tr>
                                                    <th>{t('agent-payout.date')}</th>
                                                    <td>{this.props.downlineAgentPayoutDetailsParam.date}</td>
                                                </tr>
                                                <tr>
                                                    <th>{t('agent-payout.agent')}</th>
                                                    <td>{this.state.agentDetails.agent}</td>
                                                </tr>
                                                <tr>
                                                    <th>{t('agent-payout.base-currency')}</th>
                                                    <td>{this.state.agentDetails.currency}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    }
                                    {this.state.loading
                                        ?
                                        <Skeleton count={1} />
                                        :
                                        <div className="mb-0 mt-3 justify-content-end d-flex my-xl-auto right-content">
                                            <Button typeButton='button' classValue='btn btn-blue' idValue='refresh' buttonName={t('global.refresh')} clicked={() => this.refreshHandler()} />
                                        </div>
                                    }
                                </div>
                            </div>
                
                            <div className="card box-shadow-0">
                                <div className="card-header">
                                    <h4 className="card-title mb-1">
                                        {(this.props.downlineAgentPayoutDetailsParam.orderId === null) ? t('agent-payout.downline') : t('agent-payout.payout-history')}
                                    </h4>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive table-hover datatable">
                                        <DataTable 
                                            keyField='no'
                                            data={this.state.data}
                                            columns={columns}
                                            activePage={this.state.activePage}
                                            limit={this.state.limit}
                                            totalItems={this.state.totalRecord}
                                            paginationHandler={(val) => this.datatablesChangeHandler(val, 'activePage')}
                                            sizePerPageHandler={(val) => this.datatablesChangeHandler(val, 'limit')}
                                            searchChangeHandler={(val) => this.datatablesChangeHandler(val, 'searchValue')}
                                            searchValue={this.state.searchValue}
                                            classValue='dataTable table-bordered text-justify text-center'
                                            loading={this.state.loading}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Auxiliary>
            
        }
        return (
            <Auxiliary>
                {display}
            </Auxiliary>
        )
        
    }
}

const mapStateToProps = state => {
    return {
        downlineAgentPayoutDetails: state.agentPayout.downlineAgentPayoutDetails,
        downlineAgentPayoutHistoryDetails: state.agentPayout.downlineAgentPayoutHistoryDetails
    }
}

const mapDispatchToProps = dispatch => {
    return {
        funcGetDownlineAgentPayoutDetails: (aid, date, id) => dispatch(actions.getDownlineAgentPayoutDetails(aid, date, id)),
        funcGetDownlineAgentPayoutHistoryDetails: (aid, date, id) => dispatch(actions.getDownlineAgentPayoutHistoryDetails(aid, date, id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces('translation')(AgentDownlinePayoutDetails));